// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"299":"444dfcaf75865eb5a634","974":"edf1e6438168335be88b"}[chunkId] + ".js";
};